import clsx from 'clsx';
import React from 'react';

import CtaItem, { CtaItemProps } from '../CtaItem';

import useStyles from './CtaGroup.styles';

export type CtaGroupProps = {
  ctas: CtaItemProps[];
  columns: 2 | 3 | 4 | 5 | number;
};

const CtaGroup = ({ ctas, columns = 3 }: CtaGroupProps) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, `x${columns}`)}>
      {ctas.map((ctaContent: any, i) => (
        <CtaItem link={ctaContent.link} key={`cta_${i}`} />
      ))}
    </div>
  );
};

export default CtaGroup;
